import Preloader from "../../components/custom/preloader/preloader.vue";
import {
  PROFILE_GET_DATA,
  PROFILE_GET_PASSRESULT,
  PROFILE_SAVE_DATA,
  PROFILE_SAVE_DATA_EMAIL
} from "../../util/mutationTypes.js";

import { EventBus } from "../../util/eventBus";
import { EVENT_CHANGE_LANGUAGE } from "../../util/eventType";

export default {
  components: {
    Preloader
  },
  data() {
    var validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(this.$t("profile_warn_email"));
      } else if (
        value.match(
          /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
        ) === null
      ) {
        callback(this.$t("profile_valid_email"));
      } else {
        callback();
      }
    };

    var validateOldPass = (rule, value, callback) => {
      this.checkOldPass(value, callback);
    };

    var validateNewPass = (rule, value, callback) => {
      if (!value) {
        callback(this.$t("profile_warn_new_password"));
      } else if (value.length < 6) {
        callback(this.$t("profile_warn_more_5_letters"));
      } else if (value.match(/\d+/) === null) {
        callback(this.$t("profile_warn_new_password_digit"));
      } else if (value.match(/[A-Za-z]/) === null) {
        callback(this.$t("profile_warn_new_password_letter"));
      } else {
        callback();
      }
    };

    return {
      labelPosition: "top",
      login: "",
      firmName: "",
      country: "",
      referent: "",
      emailReferent: "",
      telephonReferent: "",
      profileResult: false,
      profileResultError: false,
      profileResultEmail: false,
      profileResultErrorEmail: false,
      tourIndex: "",
      dynamicValidateFormEmail: {
        email: ""
      },
      dynamicValidateForm: {
        currentPassword: "",
        newPassword: ""
      },
      rulesEmail: {
        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: ["blur", "change"]
          }
        ]
      },
      rules: {
        currentPassword: [
          { required: true, validator: validateOldPass, trigger: "blur" }
        ],
        newPassword: [
          { required: true, validator: validateNewPass, trigger: "blur" }
        ]
      }
    };
  },
  props: {
    readOnly: {
      default: false
    }
  },
  computed: {
    userName() {
      return this.$store.state.UserStorage.login;
    },
    lang() {
      return this.$store.state.SettingStorage.language.toLowerCase();
    },
    popupWidth() {
      return this.$store.state.SettingStorage.language.toLowerCase() == "en"
        ? 230
        : 300;
    }
  },
  methods: {
    checkOldPass(value, callback) {
      this.$store
        .dispatch(PROFILE_GET_PASSRESULT, { data: { oldPassword: value } })
        .then(resp => {
          if (resp.status == 200) {
            setTimeout(() => {
              callback();
            }, 500);
          } else {
            setTimeout(() => {
              callback(this.$t("profile_warn_old_password_wrong"));
            }, 500);
          }
        })
        .catch(() => {
          setTimeout(() => {
            callback(this.$t("profile_warn_old_password_wrong") + "!");
          }, 500);
        });
    },
    changeLanguage() {
      this.loadProfile();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveProfile(formName);
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    loadProfile() {
      this.$store
        .dispatch(PROFILE_GET_DATA, { data: { lang: this.lang } })
        .then(data => {
          this.login = data.login;
          this.firmName = data.firmName;
          this.country = data.country;
          this.referent = data.referent;
          this.emailReferent = data.emailReferent;
          this.telephonReferent = data.telephonReferent;
          this.dynamicValidateFormEmail.email = data.email;
          this.tourIndex = data.tourIndex;
        });
    },
    saveProfile(formName) {
      this.profileResult = false;
      this.profileResultError = false;
      this.profileResultEmail = false;
      this.profileResultErrorEmail = false;

      if (formName == "dynamicValidateFormEmail") {
        this.$store
          .dispatch(PROFILE_SAVE_DATA_EMAIL, {
            data: {
              email: this.dynamicValidateFormEmail.email
            }
          })
          .then(resp => {
            if (resp.status == 200) {
              this.profileResultEmail = true;
              this.profileResultErrorEmail = false;
              this.loadProfile();
            } else {
              this.profileResultEmail = false;
              this.profileResultErrorEmail = true;
            }
          })
          .catch(() => {
            this.profileResultEmail = false;
            this.profileResultErrorEmail = true;
          });
      } else {
        this.$store
          .dispatch(PROFILE_SAVE_DATA, {
            data: {
              oldPassword: this.dynamicValidateForm.currentPassword,
              newPassword: this.dynamicValidateForm.newPassword
            }
          })
          .then(resp => {
            if (resp.status == 200) {
              this.profileResult = true;
              this.profileResultError = false;
              this.loadProfile();
            } else {
              this.profileResult = false;
              this.profileResultError = true;
            }
          })
          .catch(() => {
            this.profileResult = false;
            this.profileResultError = true;
          });
      }
    }
  },
  mounted() {
    EventBus.$on(EVENT_CHANGE_LANGUAGE, this.changeLanguage);
  },
  created() {
    this.loadProfile();
  },
  beforeDestroy() {
    EventBus.$off(EVENT_CHANGE_LANGUAGE, this.changeLanguage);
  }
};
